import { communicationsApi } from '@app/services'

export const markMessageAsSafe = async (
  conversationId: number,
  messageId: number,
  signal: AbortSignal
) => {
  const { data } = await communicationsApi.delete(`/conversation/${conversationId}/message/${messageId}/spam`, {signal})
  return data
}
